import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FoodShots from '../FoodShots';
import ProductReviewsContainer from './ProductReviewsContainer';
import LoggedoutProductReviewsContainer from './LoggedOutProductReviewsContainer';

function ProductReviewMeta(props) {
    const { reviewCount,
        publicUserReviews,
        isPublic,
        publicClickAction } = props;
    const [productId, setProductId] = useState(props.productId);
    useEffect(() => {
        setProductId(props.productId);
    }, [props.productId]);
    return (<div className="product__reviews product__section">
        <p className="product__reviews__header">Reviews {!!reviewCount && <span>({reviewCount})</span>}</p>
        {
            !!reviewCount
            ? <>
                <FoodShots isPublic={isPublic}
                    publicClickAction={publicClickAction}
                    productId={productId} />
                {
                    isPublic
                    ? <LoggedoutProductReviewsContainer reviews={publicUserReviews}
                        reviewCount={reviewCount}
                        publicClickAction={publicClickAction} />
                    : <ProductReviewsContainer isPublic={isPublic}
                        publicClickAction={publicClickAction}
                        reviewCount={reviewCount}
                        productId={productId} />
                }
            </>
            : <p className="product__reviews__helper">No reviews yet</p>
        }
    </div>)
};

ProductReviewMeta.propTypes = {
    productId: PropTypes.string.isRequired,
    reviewCount: PropTypes.number,
    isPublic: PropTypes.bool,
    publicClickAction: PropTypes.func,
    publicUserReviews: PropTypes.array
}

export default ProductReviewMeta;